'use client'
import { HTMLAttributes } from 'react';
import type { ReactNode } from 'react';
import type { IndexUiState } from 'instantsearch.js';
import dynamic from 'next/dynamic';
import type { LocalityType } from '../Filters/LocationFilter/LocationFilter';
import type { AgenceActiveServices } from '@/domains/agenceSite/agenceSite.types';
import { Loader } from '@/stories/atoms/Loader/Loader';
import { useHydrated } from '@/hooks/useHydrated';
import styles from './page.module.css'

export type ContextType = {
  /** sold : biens vendus (filtre vendu:true au lieu de NOT vendu:true) */
  typeOffre: 'buy' | 'rent' | 'new' | 'invest' | 'sold',
  isGroup: boolean,
  inGroup?: boolean,
  groupId?: string
}

export type SearchPageType = {
  context: ContextType,
  cityLatLng: {lat: number, lng: number},
  paramFilters?: {[attribute: string]: string},
  defaultUiState?: Partial<IndexUiState> & {maxNumeric?: {[attribute: string]: Array<number | number[]>}},
  defautlLocation?: LocalityType,
  /** commune de defautlLocation seule, sans le rayon de 5 km autour */
  exactLocation?: boolean,
  title?: string,
  subTitle?: string,
  staticResults?: ReactNode,
  /** Texte d'introduction affiché sous les filtres, avant les résultats (présent aussi dans le HTML statique) */
  intro?: ReactNode,
  noResultsMsg?: ReactNode | string
  nbResults?: number
} & Omit<HTMLAttributes<HTMLDivElement>, 'title'>

// données du site passées par SearchPageServer : les stores ne sont pas importables côté client
export type SearchPageProps = SearchPageType & {
  activeServices: AgenceActiveServices,
  nomDeDomaine: string
}

const SearchPageInstantSearch = dynamic(
  () => import('./SearchPageInstantSearch').then(m => m.SearchPageInstantSearch),
  { ssr: false, loading: () => <Loader /> }
)

export const SearchPage = ({
  context,
  cityLatLng,
  paramFilters,
  defaultUiState,
  defautlLocation,
  exactLocation,
  title,
  subTitle,
  staticResults,
  intro,
  noResultsMsg,
  nbResults,
  activeServices,
  nomDeDomaine,
  ...divProps
}: SearchPageProps) => {
  const hydrated = useHydrated()

  return (
    <div id='search-page' className={styles.page} {...divProps}>
      {!hydrated ? (
        <>
          {intro}
          {staticResults}
          <Loader className={styles.loader}/>
        </>
      ) : (
        <SearchPageInstantSearch
          context={context}
          cityLatLng={cityLatLng}
          paramFilters={paramFilters}
          defaultUiState={defaultUiState}
          defautlLocation={defautlLocation}
          exactLocation={exactLocation}
          title={title}
          subTitle={subTitle}
          intro={intro}
          noResultsMsg={noResultsMsg}
          nbResults={nbResults}
          activeServices={activeServices}
          nomDeDomaine={nomDeDomaine}
        />
      )}
    </div>
  )
}
